<template>
  <div class="d-flex flex-row md:mr-0 lg:mr-0 xl:mr-0 lg:-ml-5 lg:-mr-4" :class="{ 'iframe-mode': isInIframe }">
    <div class="relative bg-white md:shadow w-full">
      <v-card flat>
        <v-card-text class="justify-center w-full flex flex-col" style="padding: 0;">
          <div class="w-full">
            <div class="hidden md:flex text-zt-lg custom-bg pt-2 pl-2" :class="primaryTextClass">
              <zt-icon name="calendar-2" class="" />
              <div class="w-9/12 mr-4">
                <template v-if="steps.typeSelection.active">
                  <span class="ml-2">{{ $t('message.licenseComponent.licenseBox.balances') }}</span>
                </template>
                <template v-else-if="steps.resume.active">
                  <span class="ml-2">{{ $t('message.licenseComponent.licenseBox.resume') }}</span>
                </template>
                <template v-else>
                  <span class="ml-2">{{ $t('message.licenseComponent.licenseBox.requestLicense') }}</span>
                </template>
              </div>
              <button v-if="!steps.typeSelection.active" @click="handleClose" class="flex no-outline">
                <zt-icon name="times" class="float-right right-0" />
              </button>
            </div>
            <div v-if="steps.typeSelection.active" class="custom-bg p-10 md:px-6 md:py-10 main-h">
              <StepTypeSelection :tipos-lic="tiposLic" :error="error" :init-button="initBtn"
                :show-init-error="showInitError" @set-typeselected-id="tiposLic.selected = $event"
                @set-typeselected-name="tiposLic.selectedName = $event" @set-config="setConfig"
                @step-forward="stepFowardButton" />
            </div>
            <template v-if="!steps.typeSelection.active">
              <div
                class="md:h-auto desktop-steps-h custom-bg fixed overflow-auto md:overflow-hidden inset-0 z-10 md:relative md:inset-auto md:z-0"
                id="req-component-container">
                <div class="relative h-full">
                  <div
                    class="fixed z-20 lg:hidden text-white flex w-full document--header items-center px-6"
                    :class="primaryBgClass">
                    <p class="w-full text-center text-zt-lg">
                      <template v-if="steps.resume.active">
                        {{ $t('message.licenseComponent.licenseBox.resume') }}
                      </template>
                      <template v-else>
                        {{ $t('message.licenseComponent.licenseBox.requestLicense') }}
                      </template>
                    </p>
                    <button class="mr-auto md:pl-4 text-zt-xl" @click="goBackToLicenses"
                      data-vs-button="goBackToLicenses">
                      <zt-icon name="times" />
                    </button>
                  </div>
                  <template>
                    <div class="p-10 pt-24 md:pt-10 desktop-internal-box-height">
                      <StepDates v-if="steps.dateSelection.active" :feriados="feriados" :tipos-lic="tiposLic" />
                      <StepUploadFiles v-if="steps.uploadFiles && steps.uploadFiles.active" />
                      <StepApproverAndComment v-if="steps.approverSelectionAndComment.active"
                        :aprobador-seleccionado="aprobadorSeleccionado"
                        @set-approver="aprobadorSeleccionado = $event" />
                      <StepExtraOptions v-if="steps.extraOptions && steps.extraOptions.active" :tipos-lic="tiposLic" />
                      <div class="w-full mx-auto" v-if="steps.resume.active">
                        <div class="text-center custom-color-neutral text-zt-lg">
                          <discount-message :license-name="tiposLic.selectedName" />
                        </div>
                        <request-process-resume :aprobador-seleccionado="aprobadorSeleccionado"
                          :requestButtonDisabled="requestButtonDisabled" @step-backward="stepBackwardButton"
                          @request-license="requestLicense" />
                      </div>
                      <div id="alert" v-if="showWarning" class="p-10 pt-24 md:pt-10">
                        <AlertWarning @cancel-request="cancelRequest()" @remove-warning="removeWarning" />
                      </div>
                      <div id="success" v-if="showSuccess" class="p-10 pt-24 md:pt-10">
                        <AlertSuccess
                          @ok-request="handleClose()" />
                      </div>
                    </div>
                  </template>
                  <div
                    class="relative bottom-0 right-0 left-0 z-20 md:z-0 px-10 bottom-buttons-padding md:bottom-auto md:relative custom-bg"
                    v-if="!steps.typeSelection.active && !steps.resume.active && !showSuccess && !showWarning">
                    <div class="w-full mx-auto">
                      <zt-button text @click="stepBackwardButton" data-vs-button="goBack" class="w-5/12 ml-2">
                        <template v-if="steps.dateSelection.active">
                          {{ $t('message.licenseComponent.licenseBox.goOut') }}
                        </template>
                        <template v-else>
                          {{ $t('message.licenseComponent.licenseBox.back') }}
                        </template>
                      </zt-button>
                      <zt-button @click="stepFowardButton" :disabled="validStep"
                        class="w-5/12 float-right mr-2 button-shadow" data-vs-button="goNext">
                        {{ $t('message.licenseComponent.licenseBox.next') }}
                      </zt-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import Licenses from "@/apiClient/Licenses"
import UploadFiles from "@/apiClient/UploadFiles";
import { mapGetters } from "vuex"
import DiscountMessage from './DiscountMessage'
import StepTypeSelection from './StepTypeSelection'
import StepDates from './StepDates'
import StepUploadFiles from './StepUploadFiles'
import StepApproverAndComment from './StepApproverAndComment'
import StepExtraOptions from './StepExtraOptions'
import RequestProcessResume from './RequestProcessResume'
import { useWindowResize } from '@sichern/ui-elements'
import AlertSuccess from './AlertSuccess'
import AlertWarning from './AlertWarning'


export default {
  components: {
    DiscountMessage,
    StepTypeSelection,
    StepDates,
    StepUploadFiles,
    StepApproverAndComment,
    StepExtraOptions,
    RequestProcessResume,
    AlertSuccess,
    AlertWarning
  },
  inject: ['state', 'mutations'],
  data() {
    return {
      licenses: Licenses,
      tiposLic: {
        selected: "",
        selectedName: "",
        list: []
      },
      initBtn: true,
      feriados: [],
      feriadosObj: [],
      error: {
        show: false,
        message: ""
      },
      aprobadorSeleccionado: {},
      showInitError: false,
      showWarning: false,
      showSuccess: false,
      indexDisplaying: '',
      requestButtonDisabled: false,
      windowResize: useWindowResize(this),
      steps: {
        typeSelection: {
          active: true,
          index: 0
        },
        dateSelection: {
          active: false,
          index: 1
        }
      },
      idLoad: ''
    };
  },
  created() {
    this.uploadFiles = new UploadFiles();
    this.licenses = new Licenses();
    this.getTiposLic();
    this.mutations.setNivelAprobacion(this.getUser.niveles_aprobacion)
    if (this.getUser.aprobador) {
      this.aprobadorSeleccionado.id = this.getUser.aprobador.id.toString()
      this.aprobadorSeleccionado.data = `${this.getUser.aprobador.nombre} ${this.getUser.aprobador.apellido}`
    }
    this.getFeriados()
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid()
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200'
    },
    primaryBgClass() {
      return this.isInIframe ? 'bg-iframe-primary' : 'bg-zt-primary-200'
    },
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    validStep() {
      if (this.steps.dateSelection.active &&
        (this.state.request.fechaDesde === '' || this.state.request.fechaReingreso === '' || this.state.diasASolicitar === '' || !this.state.diasASolicitarValid)) {
        return true
      }
      if (this.steps.uploadFiles && this.steps.uploadFiles.active && this.state.config.uploadFilesRequired && this.state.request.documents.length === 0) {
        return true
      }
      if (
        this.steps.approverSelectionAndComment.active && ((this.state.config.cambia_aprobador === true && this.state.nivel_aprobacion !== 0 &&
          !this.aprobadorSeleccionado.id) || this.state.request.observaciones.length > 1500)
      ) {
        return true
      }
      // if(this.hasVPI && this.state.request.medioDia && (this.state.request.hoursRange === '0' || this.state.request.hoursRange === '')){
      //   return true
      // }
      return false
    },
    ...mapGetters({
      getUser: 'getUser',
      getTimerSweetAlert: 'getTimerSweetAlert'
    })
  },
  methods: {
    hasTranslationExist(translationKey) {
      try {
        const translation = this.$t(translationKey)
        return translation !== translationKey
      } catch (e) {
        return false;
      }
    },
    buildDefaultErrorMessage(errorTranslationKey) {
      const defaultMessage = errorTranslationKey.replace('message.errorReference.', '')
      if (this.$store.state.user.pais === 'BR') {
        return `Ocorreu um erro inesperado. Fornecemos o código \n para que você possa comunicar o suporte: \n\n ${defaultMessage}`
      }
      return `Ha ocurrido un error inesperado. Te proporcionamos el código \n para poder comunicar a soporte: \n\n ${defaultMessage}`
    },
    getTranslationKey(error) {
      if (typeof error.response.data.response_v2 === "boolean") {
        const code = error.response.data.results.data.response_v2.code
        return `message.errorReference.${code}`
      }
      
      const { code, message } = error.response.data.response_v2
      
      if (code === 'SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST') {
        const fullKey = `message.errorReference.${code}_${message}`
        const fallbackKey = `message.errorReference.${message}`
        return this.hasTranslationExist(fullKey) ? fullKey : fallbackKey
      }
      
      const vpErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_BAD_REQUEST$/
      if (message === 'RequestedDaysIsNotMultipleOf' || vpErrorCodeRegex.test(code)) {
        return `message.errorReference.${code}_${message}`
      }
      
      return `message.errorReference.${code}`
    },
    getTiposLic() {
      const orderBy = 'name'
      const orderType = 'asc'
      this.licenses
        .getLicenseTypes(orderBy, orderType)
        .then(response => {
          this.error.show = false;
          this.error.message = "";
          this.tiposLic.list = response.data.data;
        })
        .catch(error => {
          this.initBtn = true;
          this.error.show = true;
          const errorCode = error.response && error.response.data && error.response.data.response_v2 
            ? error.response.data.response_v2.code 
            : 'UNKNOWN_ERROR';
          this.error.message = this.$t(
            `message.errorReference.${errorCode}`
          );
        });
    },
    setConfig() {
      this.showInitError =
        this.state.config.cambia_aprobador === false &&
        _.isEmpty(this.aprobadorSeleccionado) &&
        this.state.nivel_aprobacion !== 0

      let index = 2
      if (this.state.config.canUploadFiles) {
        this.steps.uploadFiles = { active: false, index: index++ }
      }
      this.steps.approverSelectionAndComment = { active: false, index: index++ }
      if (this.state.config.periodo_liquidacion || this.state.config.francos_rotativos) {
        this.steps.extraOptions = { active: false, index: index++ }
      }
      this.steps.resume = { active: false, index: index++ }
    },
    stepFowardButton() {
      const newState = _.cloneDeep(this.steps)
      let index = ''
      _.forEach(newState, value => {
        if (value.active) {
          value.active = false
          index = value.index + 1
          return false
        }
      })
      _.forEach(newState, value => {
        if (value.index === index) {
          value.active = true
          return false
        }
      })
      this.$emit("change-step", index)
      this.steps = { ...newState }
    },
    stepBackwardButton() {
      let index = ''
      _.forEach(this.steps, value => {
        if (value.active) {
          index = value.index - 1
          if (index === 0) {
            index++
            if (this.windowResize.width > 1023) {
              this.displayWarning()
            } else {
              this.goBackToLicenses()
            }
          } else {
            value.active = false
          }
        }
      })
      if (!this.showWarning) {
        _.forEach(this.steps, value => {
          if (value.index === index) {
            value.active = true
            return
          }
        })
        this.$emit("change-step", index)
      }
    },
    async requestLicense() {
      try {
        this.requestButtonDisabled = true

        if (this.state.request.documents.length) {
          await this.requestLicenseFiles(this.state.request.documents)
        }
        await this.licenses
          .requestLicense(
            this.state.request.fechaDesde,
            this.state.request.fechaReingreso,
            this.tiposLic.selected,
            this.state.request.observaciones,
            this.state.request.medioDia,
            this.aprobadorSeleccionado.id,
            this.state.request.francos,
            this.state.request.periodoLiq,
            this.idLoad,
            this.state.request.hoursRange = 4,
            this.state.request.anticipatePayment,
            this.state.request.holiday_types
          )
          .then(() => {
            this.cleanRequestData()
            if (this.windowResize.width < 1024) {
              this.$swal({
                type: 'success',
                title: this.$t(
                  'message.LicensesSolicitudeComponent.modals.solicitudeOk'
                ),
                timer: this.getTimerSweetAlert,
                showConfirmButton: false
              }).then(() => {
                this.requestButtonDisabled = false
                this.cancelRequest()
              })
            } else {
              _.forEach(this.steps, value => {
                if (value.active) {
                  value.active = false
                  return false
                }
              })
              this.showSuccess = true
              this.mutations.updateHistory(true)
            }
          })
          .catch(error => {
            this.requestButtonDisabled = false

            const translationKey = this.getTranslationKey(error)
            const hasTranslation = this.hasTranslationExist(translationKey)

            if (!hasTranslation) {
              const defaultMessage = this.buildDefaultErrorMessage(translationKey)
              this.$swal({
                type: 'error',
                title: defaultMessage,
                showConfirmButton: true,
                confirmButtonText: this.$t('message.settingsComponent.list.okMsg'),
                customClass: 'swal-wide-popup'
              })
              return
            }
            
            let errorMessage = "";
            if (typeof error.response.data.response_v2 === "boolean") {
              let responseV2 = error.response.data.results.data.response_v2;
              errorMessage = this.$t(`message.errorReference.${responseV2.code}`);

              if (responseV2.hasOwnProperty('days')) {
                errorMessage = errorMessage.replace("x", responseV2.days);
              }
            }
            else {
              const { code, message, data } = error.response.data.response_v2
              const vpErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_BAD_REQUEST$/g.test(code);
              const errorValue = data ? data.value : '';
              if (message === 'RequestedDaysIsNotMultipleOf' && errorValue) {
                errorMessage = this.$t(`message.errorReference.${code}_${message}`, { errorValue });
              } else {
                errorMessage = vpErrorCodeRegex ? this.$t(`message.errorReference.${code}_${message}`) : this.$t(`message.errorReference.${code}`);
              }

              if (code === 'SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST') { 
                errorMessage = this.$t(translationKey)
              }
            }
            this.$swal({
              type: 'error',
              title: errorMessage,
              showConfirmButton: true,
              confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
            })
          })
      }
      catch (e) {
        this.requestButtonDisabled = false
        this.$swal({
          type: 'error',
          title: this.$t("message.workflow.uploadedError"),
          showConfirmButton: true,
          confirmButtonText: this.$t('message.settingsComponent.list.okMsg')
        })
      }
    },
    async requestLicenseFiles(documents) {
      const json = Object.assign({}, this.state.uploadFilesMetaData.json, { files: documents })
      const { data } = await this.uploadFiles.sendDocsToTemplate(this.state.uploadFilesMetaData.id, json)
      this.idLoad = data.results.data[0]
      const responses = []
      _.forEach(documents, (value) => {
        responses.push(this.licenses.sendDocsToLincense(this.idLoad, value.name, value.file))
      })
      return Promise.all(responses)
    },
    cleanRequestData() {
      this.idLoad = ''
      this.tiposLic.selected = ''
      this.tiposLic.selectedName = ''
      this.showInitError = false
      this.mutations.cleanConfig()
      this.mutations.cleanUploadFilesMetaData()
      this.mutations.cleanRequest()
      this.idLoad = ''
      if (this.getUser.aprobador) {
        this.aprobadorSeleccionado.id = this.getUser.aprobador.id.toString()
        this.aprobadorSeleccionado.data = `${this.getUser.aprobador.nombre} ${this.getUser.aprobador.apellido}`
      } else {
        this.aprobadorSeleccionado = {}
      }
    },
    handleClose() {
      if (this.showSuccess) {
        this.requestButtonDisabled = false
        this.showSuccess = false
        this.cancelRequest()
      } else {
        this.displayWarning()
      }
    },
    displayWarning() {
      _.forEach(this.steps, value => {
        if (value.active) {
          this.indexDisplaying = value.index
          value.active = false
          return false
        }
      })
      this.showSuccess = false;
      this.showWarning = true
    },
    removeWarning() {
      _.forEach(this.steps, value => {
        if (value.index === this.indexDisplaying) {
          value.active = true
          return false
        }
      })
      this.showWarning = false
    },
    goBackToLicenses() {
      this.$swal({
        type: 'warning',
        title: this.$t('message.menuComponent.modalMessage'),
        reverseButtons: true,
        showConfirmButton: true,
        confirmButtonText: this.$t('message.settingsComponent.list.okMsg'),
        showCancelButton: true,
        cancelButtonText: this.$t(
          'message.settingsComponent.list.buttonCancel'
        ),
        buttonsStyling: false,
        cancelButtonClass: 'btn buttonSwallCancelProperties',
        confirmButtonClass: 'btn buttonSwallConfirmProperties'
      }).then(value => {
        if (value.value == true) {
          this.cancelRequest()
        }
      })
    },
    cancelRequest() {
      this.cleanRequestData()
      _.forEach(this.steps, value => {
        if (value.active) {
          value.active = false
        }
      })
      this.steps.typeSelection.active = true
      this.steps.uploadFiles = {}
      this.showWarning = false
      this.indexDisplaying = ''
      this.$emit("change-step", 0)
    },
    getFeriados() {
      let from = moment().subtract(1, 'year').format('DD/MM/YYYY')
      let to = moment().add(2, 'year').format('DD/MM/YYYY')
      this.licenses
        .getHolidays('', from, to)
        .then((res) => {
          const holidays = res.data.results.data
          let arrayHolidays = []
          _.forEach(holidays, (value) => {
            let color = ''
            if (value.id_politica !== null && value.id_politica !== 0) {
              color = 'green';
            } else if (value.id_empresa !== null && value.id_empresa !== 0) {
              color = 'blue';
            } else {
              color = 'red';
            }
            arrayHolidays.push({
              'key': value.id,
              'dates': moment(value.fecha, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              'dot': {
                'color': color
              },
              'popover': {
                'label': value.detalle
              }
            })
          })
          this.feriados = arrayHolidays
        })
        .catch(() => { })
    },
  }
}
</script>

<style lang="scss">
@import './request.scss';

:global(.swal-wide-popup) {  
  max-width: 90% !important;
  width: auto !important;

  .swal2-popup {
    max-height: 90vh !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .swal2-title {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
    hyphens: auto !important;
    white-space: pre-wrap !important;
    text-align: center !important;
    font-size: 14px !important;
    line-height: 1.6 !important;
    padding: 20px !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
  
  .swal2-html-container {
    text-align: center !important;
    font-size: 13px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    word-break: break-word !important;
  }

  .swal2-actions {
    flex-shrink: 0 !important;
  }

  @media (max-width: 768px) {
    max-width: 95% !important;
    width: 95% !important;
    
    .swal2-title {
      font-size: 11px !important;
      padding: 15px !important;
    }
  }
}

/* Clases helper para iframe */
.text-iframe-primary {
  color: #2694fc !important;
}

.bg-iframe-primary {
  background-color: #2694fc !important;
}

.iframe-mode {
  ::v-deep .zt-button:not([text]) {
    background-color: #2694fc !important;
    border-color: #2694fc !important;
    
    &:hover:not(:disabled) {
      background-color: #1e7fd4 !important;
      border-color: #1e7fd4 !important;
    }
  }
  
  ::v-deep .zt-button[text] {
    color: #2694fc !important;
    
    &:hover:not(:disabled) {
      color: #1e7fd4 !important;
    }
  }
}
</style>